import React from "react";
import {
  TextInput,
  SimpleForm,
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  useEditController,
  EditProps,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import DaysOfWeekInput from "components/DaysOfWeekInput";
import { arrivalTimeLabel, schoolTimeLabel, typeList } from "./util";
import { GetParam } from "utils/tools";
import CustomEditToolbar from "components/CustomEditToolbar";
import CustomTimePickerInput from "components/CustomTimePickerInput";
import { cloneDeep } from "lodash";
import PermissionLoading from "../../components/PermissionLoading";
import EditWrapper from "../../components/EditWrapper";

const BusSchedulesEdit = (props: EditProps) => {
  const { id } = props;
  const param = GetParam();
  const { record, loading } = useEditController(props);
  if (loading) {
    return <PermissionLoading />;
  }

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Bus Schedules",
      link: `/schools/${param.get("schoolId")}/show/2`,
    },
    {
      title: id,
      link: ``,
    },
  ];

  const formatRecord = (res: any) => {
    if (res) {
      if (res.levels) {
        //parse route tags data to be prefillable by select array input
        const temp = cloneDeep(res.levels);
        const levelIds = temp.map((item: any) => {
          return item ? item.id : item;
        });
        res.levelIds = levelIds;
      }
    }
    return res;
  };

  const transform = async (data: any) => ({
    ...data,
    isMonday: data.isMonday ? true : false,
    isTuesday: data.isTuesday ? true : false,
    isWednesday: data.isWednesday ? true : false,
    isThursday: data.isThursday ? true : false,
    isFriday: data.isFriday ? true : false,
  });

  return (
    <>
      <EditWrapper breadcrumb={breadcrumb} transform={transform} {...props}>
        <SimpleForm
          record={formatRecord(record)}
          toolbar={
            <CustomEditToolbar
              redirectLink={`/schools/${param.get("schoolId")}/show/2`}
              isDeleteWithConfirm
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School and Type Schedule</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}>
              <SelectInput source="type" choices={typeList} disabled />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>

            <Grid item xs={3}>
              <TextInput source="name" label="Wave Name" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={8}>
              <ReferenceArrayInput
                source="levelIds"
                label="Select Levels"
                reference="levels"
                filter={{ SchoolId: Number(param.get("schoolId")) }}
              >
                <AutocompleteArrayInput optionText="name" />
              </ReferenceArrayInput>
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <CustomTimePickerInput
                source="schoolTime"
                label={`${schoolTimeLabel(param.get("type"))}`}
              />
            </Grid>
            <Grid item xs={4}>
              <CustomTimePickerInput
                source="arrivalTime"
                label={`${arrivalTimeLabel(param.get("type"))}`}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Days of Week</Typography>
            </Grid>

            <DaysOfWeekInput />
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default BusSchedulesEdit;
